import { MIN_IN_MS } from './times.constant';

export const EXPIRATION_TIME_SHIFT = MIN_IN_MS;
